// extracted by mini-css-extract-plugin
module.exports = {"Box":"box_Box__1oy32","Link":"box_Link__22GYz"};